import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SiteLayout } from "../components/site/SiteLayout";
import { Reveal } from "../lib/reveal";
import { useSeo } from "../lib/seo";
import { industries } from "../lib/content";
import { IndustryGlyph } from "../components/site/IndustryGlyph";
import { CTABlock } from "./ServicesPage";

export default function IndustriesPage() {
  useSeo({
    title: "Industries We Serve — Agricultural Technology Partner",
    description:
      "Wald serves South African agricultural exporters, packhouses, grower organisations, export agents and regulated bodies with farm management software, agricultural ERP and agricultural systems integration.",
    path: "/industries",
  });
  return (
    <SiteLayout>
      <section className="border-b border-border">
        <div className="container-wald py-20 md:py-28">
          <div className="eyebrow mb-6">Industries</div>
          <h1 className="font-display text-4xl md:text-6xl leading-[1.02] tracking-tight max-w-4xl">
            Deep focus across the export value chain.
          </h1>
          <p className="mt-6 max-w-2xl opacity-80 leading-relaxed text-lg">
            Every Wald engagement sits inside this world. That focus compounds — every project makes the
            next one sharper, faster and safer to ship.
          </p>
        </div>
      </section>
      <section>
        <div className="container-wald py-20">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {industries.map((ind, i) => (
              <Reveal key={ind.slug} delay={i * 60}>
                <Link
                  to={`/industries/${ind.slug}`}
                  data-testid={`industries-list-${ind.slug}`}
                  className="wald-card block overflow-hidden group"
                >
                  <div className="relative aspect-[16/9] bg-background border-b border-border">
                    <IndustryGlyph slug={ind.slug} />
                    <div className="absolute top-4 left-4 font-mono-tab text-xs bg-background/95 border border-border px-2 py-1">
                      {ind.number}
                    </div>
                  </div>
                  <div className="p-7 bg-card">
                    <h2 className="font-display text-2xl md:text-3xl tracking-tight mb-3">{ind.title}</h2>
                    <p className="text-sm md:text-base opacity-80 leading-relaxed mb-4">{ind.summary}</p>
                    <span className="inline-flex items-center gap-1.5 copper-link text-sm">
                      Explore <ArrowRight size={14} strokeWidth={2} />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <CTABlock />
    </SiteLayout>
  );
}
